import React from 'react';
import { heroData } from '../data/mock';
import { ArrowRight } from 'lucide-react';

const HeroSection = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="hero"
      className="min-h-screen flex items-center justify-center px-6 py-10 pt-6 md:pl-24"
    >
      <div className="max-w-4xl w-full">
        {/* Main content card */}
        <div 
          className="bg-[#FDFBF7]/95 border-[3px] border-[#2D2D2D] p-8 md:p-12
            animate-paper-drop"
          style={{ 
            borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px',
            boxShadow: '6px 6px 0px #2D2D2D'
          }}
        >
          {/* Decorative sparkle */}
          <div className="flex items-center gap-3 mb-6">
            <img 
              src="https://customer-assets.emergentagent.com/job_b4ea4401-b92b-497f-9584-a787add51601/artifacts/9szg6k9y_logo%20transparant.png"
              alt="BAIM Logo"
              className="w-10 h-10 object-contain"
            />
            <span className="font-architect text-[#1F4E79] text-lg">Business Agility in Motion</span>
          </div>

          {/* Main title */}
          <h1 className="font-marker text-3xl md:text-5xl lg:text-6xl text-[#2D2D2D] leading-tight mb-4">
            {heroData.title}
          </h1>
          
          {/* Highlighted subtitle */}
          <h2 
            className="font-patrick text-2xl md:text-3xl lg:text-4xl text-[#1F4E79] mb-8
              relative inline-block"
          >
            {heroData.titleHighlight}
            {/* Sketch underline */}
            <span 
              className="absolute -bottom-2 left-0 w-full h-1 bg-[#F08A24]"
              style={{ borderRadius: '255px 15px 225px 15px / 15px 225px 15px 255px' }}
            ></span>
          </h2>

          {/* Description */}
          <p className="font-architect text-lg md:text-xl text-[#2D2D2D]/80 mb-10 max-w-2xl leading-relaxed">
            {heroData.subtitle}
          </p>

          {/* CTA Button */}
          <button
            onClick={() => scrollToSection('identity')}
            className="sketch-btn flex items-center gap-3 group"
          >
            <span>{heroData.cta}</span>
            <ArrowRight className="w-5 h-5 transition-transform group-hover:translate-x-1" />
          </button>
        </div>

        {/* Decorative elements */}
        <div className="mt-8 flex justify-center gap-4">
          {[1, 2, 3].map((i) => (
            <div
              key={i}
              className="w-3 h-3 bg-[#1F4E79] border-2 border-[#2D2D2D]"
              style={{ 
                borderRadius: i === 1 ? '255px 15px 225px 15px / 15px 225px 15px 255px' :
                              i === 2 ? '15px 225px 15px 255px / 255px 15px 225px 15px' :
                              '225px 15px 255px 15px / 15px 255px 15px 225px',
                animationDelay: `${i * 0.2}s`
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
